<template>
  <div v-if="hasNotes" class="flex flex-col gap-3">
    <div class="font-medium">Pinned Notes</div>
    <div class="bg-white rounded-lg border divide-y max-h-60 overflow-y-auto">
      <div v-for="note in sortedNotes" :key="note.id" class="p-3">
        <div class="flex items-start gap-2">
          <i class="fa-solid fa-thumbtack text-primary text-xs mt-1 shrink-0" />
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-1.5 mb-0.5">
              <span
                v-if="note.commentable_type === 'User'"
                class="text-xs font-medium text-orange-600 bg-orange-50 px-1.5 py-0.5 rounded"
              >
                Customer
              </span>
              <span
                v-else
                class="text-xs font-medium text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded"
              >
                Job
              </span>
              <span class="text-xs text-gray-500">
                {{ note.user ? note.user.full_name : "System Message" }}
              </span>
              <span class="text-xs text-gray-400">
                {{ formatDate(note.created_at) }}
              </span>
            </div>
            <!-- Notes are stored as HTML (Broccoli online booking and the
                 rich-text editor both post HTML); render it the same way
                 Comments/Comment.vue does rather than escaping the markup. -->
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="text-sm text-gray-700" v-html="note.comment" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from "moment";
import { computed } from "vue";

import { Comment } from "@/typings/comment";

const props = defineProps<{
  pinnedNotes: { job: Comment[]; customer: Comment[] };
}>();

const hasNotes = computed(
  () =>
    props.pinnedNotes.job.length > 0 || props.pinnedNotes.customer.length > 0
);

const sortedNotes = computed(() =>
  [...props.pinnedNotes.job, ...props.pinnedNotes.customer].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  )
);

const formatDate = (dateStr: string): string => {
  return moment(dateStr).format("MMM D, YYYY");
};
</script>

<style scoped></style>
